import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import '../Assets/Styles/pages/login.css';
import { Form, Input, message, Alert, Modal } from 'antd';
import logoBH from '../Assets/Images/bhtrade.png';
import logoBPMS from '../Assets/Images/Logo-BPMS-4x-white-background.webp';
import logoPromoDreams from '../Assets/Images/promodreams.png';
import logoPromoLife from '../Assets/Images/logo-promolife.png';
import logoTradeMarket from '../Assets/Images/trademarket57.png';
import Swal from 'sweetalert2';
import clienteAxios from '../Utils/clienteAxios';
import setToken from '../Utils/setToken';
import Boton from '../Components/Atoms/Boton';
import decodeToken from '../Utils/decodeToken';
const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [sucess, setSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [forgotPasswordOpen, setForgotPasswordOpen] = useState(false);
  const [recoveryEmail, setRecoveryEmail] = useState('');
  const [isSubmittingRecovery, setIsSubmittingRecovery] = useState(false);
  const navigate = useNavigate();
  function usuario(event) {
    const value = event.target.value;
    setUsername(value);
  }
  //Comentario paar deploy
  function contraseña(event) {
    const value = event.target.value;
    setPassword(value);
  }
  function iniciarSesion() {
    if (isSubmitting) return;
    const email = username.trim();
    setIsSubmitting(true);
    clienteAxios
      .post('/login', { email, password: password })
      .then((response) => {
        //Decode token
        let decodedToken = decodeToken(response.data.access_token);
        localStorage.setItem('token', response.data.access_token);
        message.success(`Bienvenido ${decodedToken.user.name}`);
        setToken(response.data.access_token);
        setSuccess(true);
      })
      .catch((error) => {
        // Solo en error: si el acceso fue exitoso la pantalla se reemplaza y no hay nada que liberar.
        setIsSubmitting(false);
        const status = error?.response?.status;
        const backendMessage = error?.response?.data?.message || error?.response?.data?.msg;
        const errorText =
          backendMessage ||
          (status === 401 || status === 422
            ? 'Correo o contraseña incorrectos.'
            : 'Ocurrió un problema al iniciar sesión. Intenta de nuevo en unos minutos.');

        Swal.fire({
          icon: 'error',
          title: 'Inicio de sesión no exitoso',
          text: errorText,
          confirmButtonText: 'ACEPTAR'
        }).then(() => {
          navigate('/login');
        });
      });
  }

  function solicitarRecuperacion() {
    const email = recoveryEmail.trim();
    if (!email) {
      message.error('Ingresa tu correo electrónico');
      return;
    }

    setIsSubmittingRecovery(true);
    clienteAxios
      .post('/users/recoverAccess', { email })
      .then((response) => {
        Swal.fire({
          icon: 'success',
          title: 'Revisa tu correo',
          text:
            response?.data?.message ||
            'Si el correo está registrado, enviamos un enlace para crear una nueva contraseña.',
          confirmButtonText: 'ACEPTAR'
        }).then(() => {
          setForgotPasswordOpen(false);
          setRecoveryEmail('');
        });
      })
      .catch((error) => {
        Swal.fire({
          icon: 'error',
          title: 'No se pudo enviar el enlace',
          text:
            error?.response?.data?.message ||
            error?.response?.data?.msg ||
            'No fue posible enviar el enlace. Intenta de nuevo en unos minutos.',
          confirmButtonText: 'ACEPTAR'
        });
      })
      .finally(() => {
        setIsSubmittingRecovery(false);
      });
  }

  return (
    <>
      {sucess ? (
        <Navigate to="/" />
      ) : (
        <main className="pagina-login">
          <div className="container-login">
            <section className="wrapper-form-login" aria-labelledby="login-titulo">
              <div className="wrapper-logo-bpms">
                <img className="logobpms" src={logoBPMS} alt="BPMS Operations" />
              </div>
              <h1 id="login-titulo" className="login-titulo-oculto">
                Iniciar sesión
              </h1>
              {localStorage.getItem('token') && (
                <Alert
                  message="Tu sesión ha expirado, ingresa de nuevo."
                  type="error"
                  showIcon
                  className="login-aviso"
                />
              )}
              <Form
                onFinish={iniciarSesion}
                layout="vertical"
                requiredMark={false}
                validateTrigger={['onChange', 'onBlur']}>
                <Form.Item
                  label="Correo"
                  name="email"
                  rules={[
                    {
                      required: true,
                      message: 'Ingresa tu correo electrónico'
                    },
                    {
                      type: 'email',
                      message: 'Ingresa un correo válido'
                    }
                  ]}>
                  <Input
                    className="cajacorreo"
                    type="email"
                    placeholder={'Correo@mail.com'}
                    name="username"
                    autoComplete="username"
                    onChange={usuario}
                    value={username}
                  />
                </Form.Item>
                <Form.Item
                  label="Contraseña"
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: 'Ingresa tu contraseña'
                    }
                  ]}>
                  <Input.Password
                    className="cajacontraseña"
                    type="password"
                    placeholder={'*******'}
                    name="password"
                    autoComplete="current-password"
                    onChange={contraseña}
                    value={password}
                  />
                </Form.Item>
                <div className="forgot-password-link-wrapper">
                  <button
                    type="button"
                    className="forgot-password-link"
                    onClick={() => setForgotPasswordOpen(true)}>
                    ¿Olvidaste tu contraseña?
                  </button>
                </div>
                <div className="conten-btn-iniciar-sesion">
                  <Boton
                    type="primary"
                    block
                    htmlType="submit"
                    className="login-boton"
                    loading={isSubmitting}>
                    INICIAR SESIÓN
                  </Boton>
                </div>
              </Form>
              <div className="contenedor-logos">
                <img className="logo-bhtrade" src={logoBH} alt="Logo bhtrade" />
                <img className="logo-promodreams" src={logoPromoDreams} alt="Logo promodreams" />
                <img className="logo-trademarket" src={logoTradeMarket} alt="Logo trademarket" />
                <img className="logo-promolife" src={logoPromoLife} alt="Logo promolife" />
              </div>
            </section>
          </div>
          <Modal
            title="Recuperar contraseña"
            open={forgotPasswordOpen}
            onCancel={() => {
              if (!isSubmittingRecovery) {
                setForgotPasswordOpen(false);
              }
            }}
            footer={null}
            destroyOnClose>
            <p className="login-ayuda">
              Escribe tu correo y te enviaremos un enlace para crear una nueva contraseña.
            </p>
            <Form onFinish={solicitarRecuperacion} layout="vertical">
              <Form.Item
                label="Correo electrónico"
                name="recoveryEmail"
                rules={[
                  { required: true, message: 'Ingresa tu correo electrónico' },
                  { type: 'email', message: 'Ingresa un correo válido' }
                ]}>
                <Input
                  type="email"
                  placeholder="correo@empresa.com"
                  value={recoveryEmail}
                  onChange={(event) => setRecoveryEmail(event.target.value)}
                  disabled={isSubmittingRecovery}
                />
              </Form.Item>
              <Boton type="primary" block htmlType="submit" loading={isSubmittingRecovery}>
                ENVIAR ENLACE
              </Boton>
            </Form>
          </Modal>
        </main>
      )}
    </>
  );
};
export default Login;
